export function limitDecimals(input: string, max: number) {
  let v = (input ?? "").replace(/,/g, ".");
  if (v === "" || v === "." || v === "-" || v === "-.") return v;

  const isNeg = v.startsWith("-");
  if (isNeg) v = v.slice(1);

  const endsWithDot = v.endsWith(".");
  const [intRaw, decRaw = ""] = v.split(".");

  const intNorm = intRaw.replace(/^0+(?=\d)/, "") || (intRaw ? "0" : "");

  if (endsWithDot && decRaw.length === 0) {
    return (isNeg ? "-" : "") + (intNorm || "0") + ".";
  }

  const dec = decRaw.slice(0, Math.max(0, max));
  const out = decRaw.length > 0 ? `${intNorm || "0"}.${dec}` : intNorm || "";

  return (isNeg ? "-" : "") + out;
}

export function normalizeOnBlur(input: string, max: number) {
  if (!input || input === "." || input === "-") return "";
  const v = input.replace(/,/g, ".");
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  return n.toFixed(max);
}

// Sanea un string numérico permitiendo un único punto y máx. decimales
export const sanitizeDecimal = (raw: string, maxDecimals: number) => {
  let s = raw.replace(/[^\d.]/g, "");
  const firstDot = s.indexOf(".");
  if (firstDot !== -1) {
    s = s.slice(0, firstDot + 1) + s.slice(firstDot + 1).replace(/\./g, "");
    const [ent, dec = ""] = s.split(".");
    s = dec.length > maxDecimals ? `${ent}.${dec.slice(0, maxDecimals)}` : s;
  }
  if (s.startsWith("0") && s !== "0" && !s.startsWith("0."))
    s = String(Number(s));
  return s;
};
